var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMic1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_713)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1375 21.0056H15.8V25.8431H18.3875C18.8375 25.8431 19.2875 26.2931 19.2875 26.7431C19.2875 27.1931 18.8375 27.6431 18.3875 27.6431H10.2875C9.8375 27.6431 9.3875 27.1931 9.3875 26.7431C9.3875 26.2931 9.8375 25.8431 10.2875 25.8431H12.875V21.0056H12.5375C8.9375 21.0056 6.125 18.0806 6.125 14.5931V8.40557C6.125 7.95557 6.4625 7.61807 6.9125 7.61807C7.3625 7.61807 7.7 7.95557 7.7 8.40557V9.64307C7.8125 9.30557 8.15 9.08057 8.4875 9.08057C8.825 9.08057 9.275 9.41807 9.275 9.86807C9.275 10.3181 8.9375 10.6556 8.4875 10.6556C8.0375 10.6556 7.8125 10.4306 7.7 10.0931V14.4806C7.7 17.0681 9.8375 19.2056 12.425 19.2056H16.1375C18.725 19.2056 20.8625 17.0681 20.8625 14.4806V9.86807C20.8625 10.3181 20.525 10.6556 20.075 10.6556C19.625 10.6556 19.2875 10.3181 19.2875 9.86807C19.2875 9.41807 19.625 9.08057 20.075 9.08057C20.525 9.08057 20.8625 9.41807 20.8625 9.86807V8.29307C20.8625 7.84307 21.2 7.50557 21.65 7.50557C22.1 7.50557 22.4375 7.84307 22.4375 8.29307V14.4806C22.4375 18.0806 19.5125 20.8931 16.025 20.8931L16.1375 21.0056ZM14.225 17.5181C11.525 17.5181 9.275 15.2681 9.275 12.5681V5.70557C9.275 4.01807 10.175 2.44307 11.525 1.54307V5.36807C11.525 5.81807 11.8625 6.15557 12.3125 6.15557C12.7625 6.15557 13.1 5.81807 13.1 5.36807V0.755566C13.4375 0.643066 13.775 0.643066 14.225 0.643066C14.675 0.643066 15.0125 0.643066 15.35 0.755566V5.25557C15.35 5.70557 15.6875 6.04307 16.1375 6.04307C16.5875 6.04307 16.925 5.70557 16.925 5.25557V1.43057C18.275 2.33057 19.175 3.79307 19.175 5.59307V12.4556C19.175 15.1556 16.925 17.4056 14.225 17.4056V17.5181Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(0.5 0.643066)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMic1);
export default __webpack_public_path__ + "static/media/ic_mic_1.e6067e32b2709e129caea78d8cc07e46.svg";
export { ForwardRef as ReactComponent };